import { useEffect, useRef, useState } from "react"
import "./AdicionarNovaPermissao.css"
import { get, post } from "../../services/api"
import { logout } from "../../auth";
import Select from 'react-select'

function AdicionarNovaPermissao({ authToken, setError, refetchPermissoes, setorOptions, papelOptions, setNotifier }) {
    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';
    
    const [ origem, setOrigem ] = useState({ label: "Departamento", value: 1})
    const [ tipo, setTipo ] = useState({ label: "Administrador", value: 1 })
    const [ setor, setSetor] = useState({ label: "Selecione", value: undefined })
    const [ papel, setPapel ] = useState({ label: undefined, value: undefined })


    const [ tipoOptions, setTipoOptions ] = useState([])

    const selectStyle = {
        control: (base) => ({
            ...base,
            background: 'unset',
            borderColor: '#DCDCDC',
            borderRadius: '4px',
            fontSize: '14px',
            minHeight: '38px',
            height: 'auto',
            boxShadow: 'none',
             outline: 'none',
            '&:hover': {
                borderColor: '#BFBFBF',
            },
            '&:focus': {
                outline: 'none',
                boxShadow: 'none',
        },
        }),
    };
    
    async function setTipoOptionsWithRequest(authToken) {
        try {
            const tipoOptions = await get("/admin/permissoes/tipos", null, authToken)
            setTipoOptions(tipoOptions)
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    useEffect(() => {
        const authToken = localStorage.getItem("adminToken")

        if(authToken != null) {
            setTipoOptionsWithRequest(authToken);
        }
        
    }, [])

    function getPapelOptionsFiltrado() {
        let papeisFiltrados = papelOptions

        //Filtragem origem
        papeisFiltrados = papeisFiltrados.filter(papel => papel.origem == origem.value)

        //Filtragem tipo adm somente CDAM
        if(origem.value == 2 && tipo.value == 1) papeisFiltrados = papeisFiltrados.filter(papel => papel.additional_data3 == 10001)

        //Filtragem usuarios que ja tem a permissao devido ao setor
        if(origem.value == 2) {
            const setoresPermitidos = setorOptions.filter(setor => setor.id_tipo != tipo.value)
                                                  .map(setor => setor.id_departamento)

            papeisFiltrados = papeisFiltrados.filter(papel => papel.additional_data1 === null || setoresPermitidos.includes(papel.additional_data1))
        }
        
        //Filtragem setor
        if(origem.value == 2 && setor.value !== undefined) papeisFiltrados = papeisFiltrados.filter(papel => papel.additional_data1 == setor.value)

        return papeisFiltrados.map(papel => { 
            return { label: papel.descricao, value: papel.codigo }
        }) 
    }

    async function handleSubmit(event){
        event.preventDefault()

        const idUsuarioAtual = localStorage.getItem("idusuario")

        if(typeof idUsuarioAtual === 'undefined') {
            logout()
        } else if(setor.value == undefined && papel.value == undefined){
            setError(`${origem.value == 1 ? 'Setor' : 'Usuario'} não especificado!`)
        } else{
            const requisicao = {
                idUsuarioAtual: idUsuarioAtual,
                idOrigem: origem.value,
                idTipo: tipo.value,
                codigoPapel: papel.value == undefined && setor.value ? setor.value: papel.value
            }

            try{
                await post('/admin/permissoes', requisicao, authToken);

                setPapel({ label: undefined, value: undefined });
                refetchPermissoes();
                setNotifier(true, "Permissão adicionada com sucesso!");

            } catch (error) {
                if (error.response && error.response.data) {
                    setError(error.response.data.Mensagem || 'Erro ao adicionar permissão');
                    console.error('Erro na resposta:', error.response.data);
                } else if (error.request) {
                    setError('Sem resposta do servidor');
                    console.error('Sem resposta do servidor:', error.request);
                } else {
                    setError('Erro durante a configuração da requisição');
                    console.error('Erro durante a configuração da requisição:', error.message);
                }
            }
            
        }
    }

    return (
        <div className="filtros-consulta-wrapper">
            <div className="header">
                <span>1</span>
                <h1>Conceder Permissões</h1>
            </div>
               
            <form className="body" onSubmit={handleSubmit}>
                <div className="organizacao-wrapper">
                    <label htmlFor="origem">Organização</label>
                    <Select 
                        name="origem" 
                        options={[
                            { label: "Departamento", value: 1 }, 
                            { label: "Usuário especifico", value: 2 }
                        ]}
                        value={origem} 
                        onChange={(select) => {
                            const value = select.value
                            const label = select.label

                            setOrigem({label: label, value: value})
                            setSetor({ label: "Selecione", value: undefined })
                            setPapel({ label: undefined, value: undefined })
                        }}
                        noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        menuPortalTarget={document.body} 
                        styles={selectStyle}
                        menuShouldScrollIntoView={false}  
                    />
                </div>

                <div className="organizacao-wrapper">
                    <label htmlFor="tipo">Papel</label>
                    <Select 
                        options={[
                            ... tipoOptions.length > 0 ? tipoOptions.map(tipo => {return {label: tipo.descricao, value: tipo.id_tipo}}) : []
                        ]}
                        value={tipo} 
                        onChange={(select) => {
                            const label = select.label
                            const value = select.value
                            
                            setTipo({ label: label, value: value })
                            setSetor({ label: "Selecione", value: undefined })
                            setPapel({ label: undefined, value: undefined })
                        }}
                        noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        menuPortalTarget={document.body} 
                        styles={selectStyle}
                        menuShouldScrollIntoView={false}  
                    />
                </div>

                
                <div className="organizacao-wrapper">
                    <label htmlFor="setor">Setor</label>
                    <Select 
                        options={[ 
                            { label: "Selecione", value: undefined }, 
                            { label: "Sem setor", value: null }, 
                            ... setorOptions.length > 0 
                            ? setorOptions
                                        .filter(setor => setor.id_tipo != tipo)
                                        .map(setor => { 
                                            return { label: setor.departamento, value: setor.id_departamento }
                                        }) 
                            : []
                        ]}
                        value={setor}
                        onChange={(option) => {
                            const label = option.label
                            const value = option.value

                            setSetor({ label: label, value: value })
                            setPapel({ label: undefined, value: undefined })
                        }}
                        noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        menuPortalTarget={document.body} 
                        styles={selectStyle}
                        menuShouldScrollIntoView={false}  
                    />
                </div>

                <div className={`organizacao-wrapper ${origem.value == 1 ? 'disabled' : ''} `}>
                    <label htmlFor="papel">Usuário</label>
                    <Select 
                        options={
                            papelOptions.length > 0 
                            ? getPapelOptionsFiltrado()
                            : []
                        } 
                        value={papel}
                        onChange={(option) => {
                            const label = option.label
                            const value = option.value

                            setPapel({ label: label, value: value })

                            const user = papelOptions.filter(papel => papel.codigo == value)[0]

                            setSetor({ label: user.additional_data2, value: user.additional_data1 })
                        }} 
                        noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        menuPortalTarget={document.body} 
                        styles={selectStyle}
                        menuShouldScrollIntoView={false}
                    />
                </div>
                <button className="btn-nova-permissao" type="submit">Adicionar permissão</button>
            </form>
        </div>
    )
}

export default AdicionarNovaPermissao